<template>
<div>
  <v-toolbar style=" position: fixed;" v-show="lijstofdetail" dense>
    </v-toolbar-items>
    <v-btn style="margin: 0px;margin-left: 10px;" class="green white--text"  v-on:click.native="NieuweWerfClick" ><v-icon dark>add</v-icon></v-btn>
    <v-spacer></v-spacer>
    <v-btn style="margin: 0px;" class="blue white--text" v-on:click.native="afdrukkenClicked" ><v-icon dark>print</v-icon></v-btn>
  </v-toolbar>


  <div class="topclass" v-show="lijstofdetail">

    <div class="header" style="position: fixed;margin-top:46px">
      <div style="height: 40px;margin: 0px;padding:0px;">
        <div class="werfnrcol th">WERFNR</div>
        <div class="naamcol th">NAAM</div>
        <div class="machcol th" style="padding-top:0px;">AANTAL MACHINES</div>
      </div>
      <div style="height: 60px;margin: 0px;padding:0px;">
        <div class="werfnrcol th">
          <v-text-field class="textfieldcell"
              v-model="werfnrfilter"
              label=""
              prepend-icon="filter_list"
              @input="updateFilters"
            ></v-text-field>
          </div>
        <div class="naamcol th">
          <v-text-field class="textfieldcell"
              v-model="naamfilter"
              label=""
              prepend-icon="search"
              @input="updateFilters"
            ></v-text-field></div>
        <div class="machcol th"></div>
      </div>
      <div style="">
      </div>
    </div>
    <div class="table" style="padding-top:148px;">
      <div v-for="entry in werven" class="tr" @click="clicked(entry)">
        <div class="werfnrcol td">{{entry.werfnr}}</div><div class="naamcol td" style="text-overflow: ellipsis;">{{entry.werfnaam}}</div><div class="machcol td">{{entry.aantalMachines}}</div>
      </div>
    </div>
    <!--
    <table>
    <thead style=" position: fixed;margin-top:46px">
      <tr style="height: 60px;margin: 0px;padding:0px;">
        <th class="werfnrcol">WERFNR</th>
        <th class="naamcol">NAAM</th>
        <th class="machcol">AANTAL MACHINES</th>
      </tr>
        <th class="werfnrcol headercell">
                <v-text-field class="textfieldcell"
                    v-model="werfnrfilter"
                    label=""
                    prepend-icon="filter_list"
                    @input="updateFilters"
                  ></v-text-field>
                </th>
        <th class="naamcol headercell">
          <v-text-field class="textfieldcell"
              v-model="naamfilter"
              label=""
              prepend-icon="search"
              @input="updateFilters"
            ></v-text-field>
        </th>
        <th class="machcol"></th>
      </tr>
    </thead>
    <tbody>
      <tr >
        <td colspan="3" style="height: 158px;">
        </td>
      </tr>

      <tr v-for="entry in werven" @click="clicked(entry)">
        <td class="werfnrcol">
          <div>{{entry.werfnr}}</div>
        </td>
        <td class="naamcol" style="text-overflow: ellipsis;">
          <div>{{entry.werfnaam}}</div>
        </td>
        <td class="machcol" >
          <div>{{entry.aantalMachines}}</div>
        </td>
      </tr>

    </tbody>
  </table>
-->
  </div>


  <div class="topclass" v-show="!lijstofdetail">
    <wervendetail @backWerven="backWerven"></wervendetail>
  </div>




  <v-layout row justify-center>
    <v-dialog v-model="showNewWerfDialog" width ="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Werf Toevoegen</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="nieuwWerfVolgnr" label="werfnummer" required></v-text-field>
          <v-text-field v-model="nieuweWerfOmschr" label="naam" required></v-text-field>
          <div class="red--text">{{TError}}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="blue--text darken-1" @click.native="showNewWerfDialog = false">Sluiten</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" @click.native="nieuweWerfSaveClick">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>





</div>



</template>




<script>
import datareq from './datareq.js'
import functions from './functions.js'
import wervendetail from './wervendetail.vue'
import jsPDF from 'jspdf'
import autotable from 'jspdf-autotable'
  export default {
    components: {
      datareq,
      functions,
      wervendetail,
      jsPDF
    },
    created: function () {
      this.$bus.$on('laadWerven', this.laden)
    },
    data () {
      return {
        werven: [],
        lijstofdetail: false,
        werfnrfilter: '',
        naamfilter: '',
        showNewWerfDialog: false,
        nieuwWerfVolgnr: '',
        nieuweWerfOmschr: '',
        TError: ''
      }
    },
    methods: {
      laden: function () {
        this.lijstofdetail = true
        this.werfnrfilter = ''
        this.naamfilter = ''
        this.showNewWerfDialog = false
        this.updateFilters()
      },
      clicked: function (werf) {
        this.$bus.$emit('laadWervenDetail', [{werfnr: werf.werfnr, werfnaam: werf.werfnaam}])
        this.lijstofdetail = false
      },
      jsonWervenReceived: function (data) {
        var status = data.status
        this.werven = []
        if (status === 'OK') {
          var d = data.data
          for (var m of d) {
            if(m.werfnr !== '') {
              this.werven.push(m)
            }
          }
          //this.werven = d
        } else {
        }
      },
      updateFilters: function () {
        datareq.getData('GetWerven', {idfilter: this.werfnrfilter, werffilter: this.naamfilter, perpagina : 9999, pagina: 0}, this.jsonWervenReceived)
      },
      backWerven: function () {
        this.lijstofdetail = true
        this.updateFilters()
      },
      jsonNieuweWerf: function (data) {
        var status = data.status
        var d = data.data
        if (status === 'OK') {
          if(d === 1) {
            this.showNewWerfDialog = false
            this.laden()
          } else if (d === 2) {
            this.TError = 'Werfnummer bestaat al.'
          }
        } else {
        }
      },
      nieuweWerfSaveClick: function () {
        this.TError = ''
        if(this.nieuwWerfVolgnr != '') {
          if(this.nieuweWerfOmschr != '') {
            datareq.getData('NieuweWerf', {ID: this.nieuwWerfVolgnr, nm: this.nieuweWerfOmschr}, this.jsonNieuweWerf)
          } else {
            this.TError = 'Vul een werfnaam in.'
          }
        } else {
          this.TError = 'Vul een werfnummer in.'
        }
      },
      NieuweWerfClick: function () {
        this.nieuwWerfVolgnr = ''
        this.nieuweWerfOmschr = ''
        this.TError = ''
        this.showNewWerfDialog = true
      },
      afdrukkenClicked: function () {
        var res = this.werven
        var columns = [{header: "werfnr", dataKey: "werfnr"}, {header: "naam", dataKey: "werfnaam"}, {header: "aantal machines", dataKey: "aantalMachines"}];
        var rows = [];
        for (var i = 0; i < res.length; i++) {
          rows.push(res[i]);
        }
        // Only pt supported (not mm or in)
        var doc = new jsPDF('p', 'pt', 'a4');
        doc.text('Werven',95, 60 );
        doc.addImage(functions.getVLBLogo(), 'JPEG', 40, 40, 48, 30);

        var currentdate = new Date();
        var datetime = "Datum afdruk: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/"
                + currentdate.getFullYear() + " - "
                + currentdate.getHours() + ":"
                + currentdate.getMinutes();

        doc.setFontSize(8);
        doc.text(datetime,550, 60 ,'right');

        var header = function (data) {
        }

        var totalPagesExp = "{total_pages_count_string}";
        var footer = function (data) {
        var str = "Pagina " + data.pageCount;
        if (typeof doc.putTotalPages === 'function') {
            str = str + " van " + totalPagesExp;
        }
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 30);
        }


        var options = {
          addPageContent: header,
            startY: 75,
            styles: {
               // font: 'courier',
                fillStyle: 'DF',
                lineColor: [128, 128, 128],
                fontSize: 7,
                lineWidth: 0,
                overflow: 'linebreak'
            },
            headerStyles: {
                fillColor: [200, 200, 200],
                fontSize: 7,
                cellPadding : 2
            },
            bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: 0
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255]
            },
            columnStyles: {
                id: {
                    columnWidth: 90
                },
                omsch: {
                    columnWidth: 175
                },
                loc: {
                    columnWidth: 90
                }
            },
            vorigesoort : "",
            drawRow: function (row, data) {
                doc.setFontStyle('bold');
                doc.setFontSize(10);
            },
            createdCell: function (cell, data) {
                if (data.column.dataKey === 'werfnr') {
                    cell.styles.halign = 'left';
                } else if (data.column.dataKey === 'werfnaam') {
                    cell.styles.halign = 'left';
                    //cell.text = "";
                } else if (data.column.dataKey === 'aantalMachines') {
                    cell.styles.halign = 'left';
                    //cell.text = "";
                }
            },
            addPageContent: footer
        }


        doc.autoTable({columns: columns, body: rows,
            startY: 75,
            styles: {
               // font: 'courier',
                fillStyle: 'DF',
                lineColor: [128, 128, 128],
                fontSize: 7,
                lineWidth: 0,
                overflow: 'linebreak'
            },
            headStyles: {
                fillColor: [200, 200, 200],
                fontSize: 7,
                cellPadding : 2
            },
            bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: 0
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255]
            },
            columnStyles: {
                id: {
                    cellWidth: 90
                },
                omsch: {
                    cellWidth: 175
                },
                loc: {
                    cellWidth: 90
                }
            }
          });

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        doc.save('werflijst.pdf');
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'


</style>


<style scoped>
body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

.table {
  width: 591px;
  border: 2px solid gray;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 0px 10px darkgrey;
  border-collapse: collapse;
}

th {
  background-color: #ebebeb;
  color: black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -user-select: none;
  cursor: auto;
}


.topclass {
  padding: 0px;
  padding-top: 0px;
}

.alignright {
  text-align: right;
}

.bold {
  font-weight: bold;
}

.tr {
  cursor: pointer;
  text-align: left;
  white-space: pre-wrap;

}

.tr:nth-child(odd) {
  background-color: #f2f2f2;
  color: #000000;
}

.tr:hover {
  background-color: #cde9ef;
  cursor: pointer;
}

.td {
  padding: 5px 5px;
  margin: 0px;
  border: 1px solid black;
  display: inline-block;
}

.header {
  background-color: #ebebeb;
}
.th {
  background-color: #ebebeb;
  color: black;
  padding: 5px 5px;
  margin: 0px;
  padding-left: 10px;
  display: inline-block;
}

.werfnrcol {
  width: 100px;min-width: 90px;max-width: 90px;
}

.naamcol {
  width: 400px;min-width: 400px;max-width: 400px;
}

.machcol {
  width: 90px;min-width: 90px;max-width: 90px;
}

.headercell {
  height: 10px; margin: 0px; padding: 0px;
}

.textfieldcell {
   margin: 0px; padding: 0px;
}

.oranjeachtergrond {
  background-color: orange;
}

.rodeachtergrond {
  background-color: red;
}


</style>



// WEBPACK FOOTER //
// werven.vue?3d7801aa